import { getStore } from '../store/store';
import { action } from 'satcheljs/lib/legacy';

export default action('undoLatestDelayedMailItem')(function() {
    const undoItem = getStore().delayedMailItems.pop();
    if (undoItem) {
        window.clearTimeout(undoItem.timeoutId);
        undoItem.afterCancel(undoItem.data);
    }
});
